export default "__VITE_ASSET__CCVWOArI__"